<template>
  <div class="comparetableportfolio">
    <table class="stratstablecomp" :class="'stratstablecomp' + _uid" style="display: none;" cellspacing="0" role="presentation" aria-describedby="stratscomparetable">
      <thead>
        <tr class="trstratstitle">
          <td colspan="13"><span class="stratstitle"> {{ $t('stratsData.valuation-by') }} {{ groupdata.groupname }}</span></td>
        </tr>
        <tr class="trstratssubtitle">
          <td>&nbsp;</td>

          <td class="tdstratssubtitle1"><span class="stratssubtitle1">{{ groupdata.port1.name }} #</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle2">{{ groupdata.port2.name }} #</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle1">{{ groupdata.port1.name }} # %</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle2">{{ groupdata.port2.name }} # %</span></td>

          <td class="tdstratssubtitle1"><span class="stratssubtitle1">{{ groupdata.port1.name }} {{ groupdata.area.name }} Σ</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle2">{{ groupdata.port2.name }} {{ groupdata.area.name }} Σ</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle1">{{ groupdata.port1.name }} {{ groupdata.area.name }} Avg</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle2">{{ groupdata.port2.name }} {{ groupdata.area.name }} Avg</span></td>

          <td class="tdstratssubtitle1"><span class="stratssubtitle1">{{ groupdata.port1.name }} {{ groupdata.value.name }} Σ</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle2">{{ groupdata.port2.name }} {{ groupdata.value.name }} Σ</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle1">{{ groupdata.port1.name }} {{ groupdata.value.name }} Avg</span></td>
          <td class="tdstratssubtitle1"><span class="stratssubtitle2">{{ groupdata.port2.name }} {{ groupdata.value.name }} Avg</span></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in groupkeys" :key="index" class="groupopttr">
          <td class="grouptdval">{{ item }}</td>

          <td>{{ getunits(index, 1) }}</td>
          <td>{{ getunits(index, 2) }}</td>
          <td>{{ getunitspercent(index, 1) }}</td>
          <td>{{ getunitspercent(index, 2) }}</td>

          <td>{{ getsqm(index, 1) }}</td>
          <td>{{ getsqm(index, 2) }}</td>
          <td>{{ getsqmpercent(index, 1) }}</td>
          <td>{{ getsqmpercent(index, 2) }}</td>

          <td>{{ getvalue(index, 1) }}</td>
          <td>{{ getvalue(index, 2) }}</td>
          <td>{{ getvaluepercent(index, 1) }}</td>
          <td>{{ getvaluepercent(index, 2) }}</td>

        </tr>
      </tbody>
      <tfoot>
        <tr class="trstratsfooter">
          <td>&nbsp;</td>

          <td>{{ gettotal('units1') }}</td>
          <td>{{ gettotal('units2') }}</td>
          <td>{{ gettotal('unitspercent1') }}</td>
          <td>{{ gettotal('unitspercent2') }}</td>

          <td>{{ gettotal('sqm1') }}</td>
          <td>{{ gettotal('sqm2') }}</td>
          <td>{{ gettotal('sqmavg1') }}</td>
          <td>{{ gettotal('sqmavg2') }}</td>

          <td>{{ gettotal('val1') }}</td>
          <td>{{ gettotal('val2') }}</td>
          <td>{{ gettotal('valavg1') }}</td>
          <td>{{ gettotal('valavg2') }}</td>
        </tr>
      </tfoot>
    </table>
    <hot-table ref="hotTableCompare" :settings="tablesettings" />
  </div>
</template>
<script>
import exportTable from '@/components/mixins/exportTable'
import { _ } from 'vue-underscore'
import { mapState } from 'vuex'
import 'handsontable/dist/handsontable.full.css'
import { HotTable } from '@handsontable/vue'
// import Handsontable from 'handsontable'
import { registerAllModules } from 'handsontable/registry'
registerAllModules()
export default {
  components: { HotTable },
  mixins: [exportTable],
  props: ['groupdata'],
  data() {
    return {
      tablesettings: {
        data: [],
        rowHeaders: false,
        colHeaders: [],
        readOnly: true,
        height: 'auto',
        columnSorting: true,
        contextMenu: ['alignment', 'freeze_column', 'unfreeze_column'],
        manualColumnFreeze: true,
        fixedColumnsLeft: 1,
        licenseKey: 'non-commercial-and-evaluation' // for non-commercial use only
      }
    }
  },
  computed: {
    groupkeys: function() {
      const vm = this
      return Object.keys(vm.groupdata.port1.groupdata)
    },
    ...mapState('portfolio', {
      currentportfolio: (state) => state.currentportfolio,
      compareportfolio: (state) => state.compareportfolio
    })
  },
  watch: {
    groupdata: function() {
      this.loadtable()
    },
    currentportfolio: function() {
      this.loadtable()
    },
    compareportfolio: function() {
      this.loadtable()
    }
  },
  mounted() {
    // Se añade el id del portfolio en la primera carga
    // this.loadtable()
  },
  methods: {
    loadtable() {
      const vm = this
      const headers = [
        vm.groupdata.groupname,
        vm.groupdata.port1.name + ' ' + vm.$t('units'),
        vm.groupdata.port2.name + ' ' + vm.$t('units'),
        vm.groupdata.port1.name + ' % ' + vm.$t('units'),
        vm.groupdata.port2.name + ' % ' + vm.$t('units'),
        vm.groupdata.port1.name + ' ' + vm.groupdata.area.name + ' Σ',
        vm.groupdata.port2.name + ' ' + vm.groupdata.area.name + ' Σ',
        vm.groupdata.port1.name + ' ' + vm.groupdata.area.name + ' Avg',
        vm.groupdata.port2.name + ' ' + vm.groupdata.area.name + ' Avg',
        vm.groupdata.port1.name + ' ' + vm.groupdata.value.name + ' Σ',
        vm.groupdata.port2.name + ' ' + vm.groupdata.value.name + ' Σ',
        vm.groupdata.port1.name + ' ' + vm.groupdata.value.name + ' Avg',
        vm.groupdata.port2.name + ' ' + vm.groupdata.value.name + ' Avg'
      ]
      vm.tablesettings.colHeaders = headers
      const datacomp = vm.groupkeys.map((item, index) => {
        return [
          item,
          vm.getunits(index, 1),
          vm.getunits(index, 2),
          vm.getunitspercent(index, 1),
          vm.getunitspercent(index, 2),
          vm.getsqm(index, 1),
          vm.getsqm(index, 2),
          vm.getsqmpercent(index, 1),
          vm.getsqmpercent(index, 2),
          vm.getvalue(index, 1),
          vm.getvalue(index, 2),
          vm.getvaluepercent(index, 1),
          vm.getvaluepercent(index, 2)
        ]
      })
      datacomp.push([
        '***' + vm.$t('total') + '***',
        vm.gettotal('units1'),
        vm.gettotal('units2'),
        vm.gettotal('unitspercent1'),
        vm.gettotal('unitspercent2'),
        vm.gettotal('sqm1'),
        vm.gettotal('sqm2'),
        vm.gettotal('sqmavg1'),
        vm.gettotal('sqmavg2'),
        vm.gettotal('val1'),
        vm.gettotal('val2'),
        vm.gettotal('valavg1'),
        vm.gettotal('valavg2')
      ])
      this.tablesettings.data = datacomp
      this.$refs.hotTableCompare.hotInstance.updateSettings(this.tablesettings)
    },
    getunits(keyindex, portnumber) {
      const vm = this
      const keys = vm.groupkeys
      let resval = null
      if (portnumber === 1) {
        if (!vm.groupdata.port1.groupdata[keys[keyindex]]) { return '-' }
        resval = vm.groupdata.port1.groupdata[keys[keyindex]].length
        // vm.units1.push(resval)
      } else {
        if (!vm.groupdata.port2.groupdata[keys[keyindex]]) { return '-' }
        resval = vm.groupdata.port2.groupdata[keys[keyindex]].length
        // vm.units2.push(resval)
      }
      return resval
    },
    getunitspercent(keyindex, portnumber) {
      const vm = this
      const keys = vm.groupkeys
      let resval = null
      if (portnumber === 1) {
        if (!vm.groupdata.port1.groupdata[keys[keyindex]]) { return '-' }
        resval = ((vm.groupdata.port1.groupdata[keys[keyindex]].length * 100) / vm.currentportfolio.data.length).toFixed(2)
        // vm.units1percent.push(resval)
      } else {
        if (!vm.groupdata.port2.groupdata[keys[keyindex]]) { return '-' }
        resval = ((vm.groupdata.port2.groupdata[keys[keyindex]].length * 100) / vm.compareportfolio.data.length).toFixed(2)
        // vm.units2percent.push(resval)
      }
      return resval
    },
    getsqm(keyindex, portnumber) {
      const vm = this
      const keys = vm.groupkeys
      let resval = null
      if (portnumber === 1) {
        if (!vm.groupdata.port1.groupdata[keys[keyindex]]) { return '-' }
        resval = _.reduce(
          vm.groupdata.port1.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.area.id]
          },
          0
        ).toFixed(2)
        // vm.sqm1.push(resval)
      } else {
        if (!vm.groupdata.port2.groupdata[keys[keyindex]]) { return '-' }
        resval = _.reduce(
          vm.groupdata.port2.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.area.id]
          },
          0
        ).toFixed(2)
        // vm.sqm2.push(resval)
      }
      return resval
    },
    getsqmpercent(keyindex, portnumber) {
      const vm = this
      const keys = vm.groupkeys
      let resval = null
      if (portnumber === 1) {
        if (!vm.groupdata.port1.groupdata[keys[keyindex]]) { return '-' }
        resval = (_.reduce(
          vm.groupdata.port1.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.area.id]
          },
          0
        ) / vm.groupdata.port1.groupdata[keys[keyindex]].length).toFixed(2)
        // vm.sqm1percent.push(resval)
      } else {
        if (!vm.groupdata.port2.groupdata[keys[keyindex]]) { return '-' }
        resval = (_.reduce(
          vm.groupdata.port2.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.area.id]
          },
          0
        ) / vm.groupdata.port2.groupdata[keys[keyindex]].length).toFixed(2)
        // vm.sqm2percent.push(resval)
      }
      return resval
    },
    getvalue(keyindex, portnumber) {
      const vm = this
      const keys = vm.groupkeys
      let resval = null
      if (portnumber === 1) {
        if (!vm.groupdata.port1.groupdata[keys[keyindex]]) { return '-' }
        resval = _.reduce(
          vm.groupdata.port1.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.value.id]
          },
          0
        ).toFixed(2)
        // vm.val1.push(resval)
      } else {
        if (!vm.groupdata.port2.groupdata[keys[keyindex]]) { return '-' }
        resval = _.reduce(
          vm.groupdata.port2.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.value.id]
          },
          0
        ).toFixed(2)
        // vm.val2.push(resval)
      }
      return resval
    },
    getvaluepercent(keyindex, portnumber) {
      const vm = this
      const keys = vm.groupkeys
      let resval = null
      if (portnumber === 1) {
        if (!vm.groupdata.port1.groupdata[keys[keyindex]]) { return '-' }
        resval = (_.reduce(
          vm.groupdata.port1.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.value.id]
          },
          0
        ) / vm.groupdata.port1.groupdata[keys[keyindex]].length).toFixed(2)
        // vm.val1percent.push(resval)
      } else {
        if (!vm.groupdata.port2.groupdata[keys[keyindex]]) { return '-' }
        resval = (_.reduce(
          vm.groupdata.port2.groupdata[keys[keyindex]],
          function(memo, item) {
            return memo + item[vm.groupdata.value.id]
          },
          0
        ) / vm.groupdata.port2.groupdata[keys[keyindex]].length).toFixed(2)
        // vm.val2percent.push(resval)
      }
      return resval
    },
    gettotal(key) {
      const vm = this
      let resval = 0
      let contkeys = 0
      vm.groupkeys.forEach(item => {
        if (key === 'units1') {
          if (vm.groupdata.port1.groupdata[item]) {
            resval += vm.groupdata.port1.groupdata[item].length
          }
        } else if (key === 'units2') {
          if (vm.groupdata.port2.groupdata[item]) {
            resval += vm.groupdata.port2.groupdata[item].length
          }
        } else if (key === 'unitspercent1') {
          if (vm.groupdata.port1.groupdata[item]) {
            resval += (vm.groupdata.port1.groupdata[item].length * 100) / vm.currentportfolio.data.length
          }
        } else if (key === 'unitspercent2') {
          if (vm.groupdata.port2.groupdata[item]) {
            resval += (vm.groupdata.port2.groupdata[item].length * 100) / vm.compareportfolio.data.length
          }
        } else if (key === 'sqm1') {
          if (vm.groupdata.port1.groupdata[item]) {
            resval += _.reduce(
              vm.groupdata.port1.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.area.id]) { valaux = item2[vm.groupdata.area.id] }
                return memo + valaux
              },
              0
            )
          }
        } else if (key === 'sqm2') {
          if (vm.groupdata.port2.groupdata[item]) {
            resval += _.reduce(
              vm.groupdata.port2.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.area.id]) { valaux = item2[vm.groupdata.area.id] }
                return memo + valaux
              },
              0
            )
          }
        } else if (key === 'sqmavg1') {
          if (vm.groupdata.port1.groupdata[item]) {
            contkeys += vm.groupdata.port1.groupdata[item].length
            resval += (_.reduce(
              vm.groupdata.port1.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.area.id]) { valaux = item2[vm.groupdata.area.id] }
                return memo + valaux
              },
              0
            ))
          }
        } else if (key === 'sqmavg2') {
          if (vm.groupdata.port2.groupdata[item]) {
            contkeys += vm.groupdata.port2.groupdata[item].length
            resval += (_.reduce(
              vm.groupdata.port2.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.area.id]) { valaux = item2[vm.groupdata.area.id] }
                return memo + valaux
              },
              0
            ))
          }
        } else if (key === 'val1') {
          if (vm.groupdata.port1.groupdata[item]) {
            resval += _.reduce(
              vm.groupdata.port1.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.value.id]) { valaux = item2[vm.groupdata.value.id] }
                return memo + valaux
              },
              0
            )
          }
        } else if (key === 'val2') {
          if (vm.groupdata.port2.groupdata[item]) {
            resval += _.reduce(
              vm.groupdata.port2.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.value.id]) { valaux = item2[vm.groupdata.value.id] }
                return memo + valaux
              },
              0
            )
          }
        } else if (key === 'valavg1') {
          if (vm.groupdata.port1.groupdata[item]) {
            contkeys += vm.groupdata.port1.groupdata[item].length
            resval += (_.reduce(
              vm.groupdata.port1.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.value.id]) { valaux = item2[vm.groupdata.value.id] }
                return memo + valaux
              },
              0
            ))
          }
        } else if (key === 'valavg2') {
          if (vm.groupdata.port2.groupdata[item]) {
            contkeys += vm.groupdata.port2.groupdata[item].length
            resval += (_.reduce(
              vm.groupdata.port2.groupdata[item],
              function(memo, item2) {
                let valaux = 0
                if (item2[vm.groupdata.value.id]) { valaux = item2[vm.groupdata.value.id] }
                return memo + valaux
              },
              0
            ))
          }
        }
      })
      if (key.indexOf('avg') > 0) {
        if (contkeys === 0) {
          return 0
        }
        return (resval / contkeys).toFixed(2)
      } else {
        return resval.toFixed(2)
      }
    }
  }
}
</script>

<style scoped>
.comparetableportfolio {
  margin-top: 10px;
  margin-bottom: 10px;
}
.stratstablecomp {
    width: 90vw;
    display: none;
}

    .stratstablecomp tr td {
        padding: 0px;
        /*border:1px solid green;*/
    }

.stratstitle {
    font-weight: bold;
    font-size: 1.1em;
}

.trstratsfooter {
  border-top: 1px solid black;
}

.trstratsfooter td {
  font-weight: bold;
  padding-right: 3px !important;
  border-top: 1px solid black;
}

.trstratstitle {
    border-bottom: 4px solid;
}

.trstratsheaders td {
  border-bottom: 2px solid;
  cursor: pointer;
}
.stratssubtitle1 {
    font-size: 0.8em;
}

.stratssubtitle2, .stratssubtitle3, .stratssubtitle4 {
    font-weight: bold;
    font-size: 0.8em;
}

.tdstratssubtitle2, .tdstratssubtitle3, .tdstratssubtitle4 {
    text-align: center;
    background-image: linear-gradient(black, black 100%);
    background-size: 98% 1px;
    background-repeat: no-repeat;
    background-position: center bottom;
}

.trstratsheaders {
    font-weight: bold;
    font-size: 0.85em;
    border-bottom: 2px solid;
    text-align: center;
}

.trstratsdata {
    font-size: 0.9em;
}

    .trstratsdata td {
        text-align: right;
    }

        .trstratsdata td span {
            padding-right: 10px;
        }

.tdstratsdata1 {
    text-align: left !important;
}

.trstratsdatatotal {
    border-top: 2px solid;
    border-bottom: 2px solid;
    font-weight: bold;
    font-size: 0.9em;
}

    .trstratsdatatotal td {
        text-align: right;
    }

        .trstratsdatatotal td span {
            padding-right: 10px;
        }

.tdstratsdata1total {
    text-align: left !important;
}

.stratstable tbody {
    font-size: 9pt;
}

.trstratstitle {
    border-bottom: 3px solid #1e3cff;
}

.trstratstitle td {
    border-bottom: 3px solid #1e3cff;
}

.trstratsdatatotal td {
    border-bottom: 3px solid #1e3cff;
    border-top: 3px solid #1e3cff;
}

.stratstitle {
    font-size: 1.2em !important;
}

#btnprintstrats i {
    color: black !important;
}

.stratsinternal {
    padding: 15px !important;
}

.stratstable {
    margin-left: 10px !important;
}

    .stratstable tr td {
        line-height: 2;
    }

.trstratsdatatotal {
    border-top: 2px solid #1e3cff !important;
    border-bottom: 2px solid #1e3cff !important;
}

.tdstratssubtitle1 span, .tdstratssubtitle2 span, .tdstratssubtitle3 span, .tdstratssubtitle4 span {
    font-weight: bold;
}
</style>
